module.exports = __webpack_public_path__ + "media/src/images/icon/check-mark-on-54e7b88648930c64fe27951f237bb904.png";